<div class="inner-container product-list">
  <div class="card">
    <div class="grid">
      <!-- Display Category Title -->
      <div class="col-12">
        @if (category) {
          <h2 class="text-center">{{ category.name }}</h2>
        }
      </div>

      <!-- Mobile Filters Component -->
      @if (isMobile()) {
        <app-mobile-filters
          [sortingOptions]="sortingOptions"
          [leadCategoryId]="category && category.is_company ? category.id : undefined"
          [(visible)]="mobileFiltersVisible"
          [(selectedCategoryIds)]="selectedCategoryIds"
          [(selectedSort)]="selectedSort"
          [(search)]="search"
          (applyFilters)="applyFilters()"
        />
      }

      <!-- Categories filters -->
      @if (hasCategories && category && !isMobile()) {
        <div class="col-12 md:col-3 desktop-filters">
          <p-accordion [value]="'1'" [multiple]="false" class="filters-accordion">
            <p-accordion-panel [value]="'1'">
              <p-accordion-header>
                <div class="flex align-items-center gap-2">
                  <img
                    ngSrc="assets/img/icons/filters/filters.svg"
                    alt="filters"
                    width="20"
                    height="20"
                  />
                  <span>Filters</span>
                </div>
              </p-accordion-header>
              <p-accordion-content>
                <app-category-filter
                  [(selectedCategoryIds)]="selectedCategoryIds"
                  [(hasCategories)]="hasCategories"
                  [leadCategoryId]="category.is_company ? category.id : undefined"
                  (filtersChanged)="applyFilters()"
                />
              </p-accordion-content>
            </p-accordion-panel>
          </p-accordion>
        </div>
      }
      <!-- Products List -->
      <div [ngClass]="hasCategories ? 'col-12 md:col-9' : 'md:col-12'">
        <!-- Search and Sort Section -->
        @if (products.length) {
          <div class="grid mb-5">
            <div class="col-12 sm:col-8 desktop-search">
              <span class="p-input-icon-right block">
                <input
                  type="text"
                  class="search-input"
                  pInputText
                  placeholder="Search products"
                  [style]="{ width: '100%' }"
                  [(ngModel)]="search"
                  (ngModelChange)="applyFilters()"
                />
                <i class="pi pi-search"></i>
              </span>
            </div>
            <div class="col-12 sm:col-4 desktop-sort">
              <p-select
                [options]="sortingOptions"
                [(ngModel)]="selectedSort"
                placeholder="Sort By"
                [style]="{ width: '100%' }"
                [showClear]="true"
                (onChange)="applyFilters()"
              ></p-select>
            </div>
          </div>
        }

        <div class="grid">
          <!-- Loading skeletons -->
          @if (isLoading || categoryLoading) {
            @for (skeleton of skeletons; track $index) {
              <div class="col-6 md:col-3">
                <div class="product">
                  <div class="mb-3 product-container">
                    <div class="product-price-container">
                      <p-skeleton width="50px" height="16px" borderRadius="12px"></p-skeleton>
                    </div>
                    <div class="image-skeleton">
                      <p-skeleton width="100%" height="208px"></p-skeleton>
                    </div>
                    <div class="flex flex-column align-items-center mt-3">
                      <p-skeleton width="115px" height="16px"></p-skeleton>
                      <p-skeleton width="135px" height="16px"></p-skeleton>
                    </div>
                  </div>
                </div>
              </div>
            }
          } @else {
            <!-- Products Grid -->
            @if (products.length > 0) {
              <div
                class="product-grid"
                [ngStyle]="{
                  'grid-template-columns': 'repeat(' + productsPerRow + ', 1fr)'
                }"
              >
                @for (product of products; track product.id) {
                  <div class="product-item">
                    <app-product-item [product]="product"></app-product-item>
                  </div>
                }
              </div>
            } @else {
              <div class="no-products">
                <p class="text-center text-lg text-500">
                  No products available at the moment. Please check back later!
                </p>
              </div>
            }
          }
        </div>
      </div>

      <!-- Pagination -->
      @if (!isLoading && paginatorOptions.last_page > 1) {
        <div class="col-12">
          <p-paginator
            [rows]="paginatorOptions.rows"
            [first]="paginatorOptions.first"
            [totalRecords]="paginatorOptions.total"
            (onPageChange)="onPageChange($event)"
          ></p-paginator>
        </div>
      }
    </div>
  </div>
</div>
